<template>
  <TelemetryEventBaseOverlay />
</template>

<script>
import TelemetryEventBaseOverlay from '@/components/overlays/telemetry-event/TelemetryEventBaseOverlay';

export default {
  name: 'TelemetryEventDefaultOverlay',
  components: {
    TelemetryEventBaseOverlay
  }
};
</script>
